import { cn } from '@/lib/utils';

interface ProgressBarProps {
  value: number;
  showLabel?: boolean;
  size?: 'sm' | 'md';
  className?: string;
}

function getColor(value: number) {
  if (value >= 70) return 'bg-emerald-500';
  if (value >= 30) return 'bg-amber-500';
  return 'bg-red-500';
}

export function ProgressBar({ value, showLabel = true, size = 'md', className }: ProgressBarProps) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <div className={cn('flex-1 overflow-hidden rounded-full bg-muted', size === 'sm' ? 'h-1.5' : 'h-2')}>
        <div
          className={cn('h-full rounded-full transition-all', getColor(clamped))}
          style={{ width: `${clamped}%` }}
        />
      </div>
      {showLabel && <span className="text-xs font-medium tabular-nums text-muted-foreground">{clamped}%</span>}
    </div>
  );
}
